import { StateComponent } from './StateComponent';
import { Loader } from '../../Loader';
export function DialogLoading(props) {
    return <StateComponent icon={<Loader size={24}/>} {...props}/>;
}
